import { Component } from '@angular/core';
import { ApiService } from '../api/api.service';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe, JsonPipe } from '@angular/common';
import { Router } from '@angular/router';
import {  DropDownButtonComponent, Button } from '@progress/kendo-angular-buttons';
import { AuthContentComponent } from "../auth-content/auth-content.component";

@Component({
  selector: 'app-main',
  imports: [AsyncPipe, JsonPipe, DropDownButtonComponent, Button, AuthContentComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.css',
})
export class MainComponent {
   

  constructor(private api: ApiService, public auth: AuthService,private router: Router) { 

    this.api.test('test').then(r => {
      this.msg = r;
    });
  }


  public msg = 'main works!';

  loginWithRedirect() {
    this.auth.loginWithRedirect({
      appState: { target: this.router.url }
    });
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }


}
